import type * as Runtypes from 'runtypes';
import { GlobalLogger } from '@bbkAdminUtils/GlobalLogger';

export const validateSchema = <T extends unknown>(
  Schema: Runtypes.Runtype.Core<T>,
  throwIfInvalid: boolean = false
) => {
  return function (data: unknown): T {
    try {
      return Schema.check(data);
    } catch (err) {
      const e = err as Runtypes.ValidationError;
      console.warn(e.message);
      GlobalLogger.error(e, data);
      if (throwIfInvalid) throw e;
      return data as T;
    }
  };
};
